import { BodyText, MinutiaeText, Space } from "@classdojo/web/nessie";

type ToolkitGridItemProps = {
  index: number;
  title: string;
  subTitle?: string;
  imgSrc?: string;
  onItemClick: VoidFunction;
  imgBackgroundSize?: string;
  noBorder?: boolean;
};

function ToolkitGridItem(props: ToolkitGridItemProps) {
  return (
    <div>
      <div
        key={props.index}
        sx={{
          textAlign: "center",
          flex: 1,
          border: props.noBorder ? "none" : "dt_functional",
          borderRadius: "dt_radius_s",
          overflow: "hidden",
        }}
        onClick={() => props.onItemClick()}
      >
        <div
          sx={{
            height: 160,
            backgroundImage: `url(${props.imgSrc})`,
            backgroundColor: "dt_background_primary",
            backgroundSize: props.imgBackgroundSize || "cover",
            backgroundPosition: "50% 50%",
          }}
        />
      </div>
      <Space size="xs" />
      <div sx={{ marginLeft: "dt_xxs", position: "relative" }}>
        <BodyText>{props.title}</BodyText>
        {props.subTitle && <MinutiaeText kind="disabled">{props.subTitle}</MinutiaeText>}
      </div>
      <Space size="xs" />
    </div>
  );
}

export default ToolkitGridItem;
